import { ProductKeys } from '@config/keys/product.keys';
import { TreeCategoryWithProduct } from '@core/models/product.model';

/**
 * True when every product in the tree belongs to `shopId`.
 * An empty tree matches: the shop may simply have no visible products yet.
 */
export function catalogTreeMatchesShop(
  categories: TreeCategoryWithProduct[] | undefined,
  shopId: string | undefined,
): boolean {
  if (!shopId) {
    return false;
  }
  const shopIds = collectProductShopIds(categories ?? []);
  if (shopIds.size === 0) {
    return true;
  }
  return shopIds.size === 1 && shopIds.has(shopId);
}

function collectProductShopIds(
  categories: TreeCategoryWithProduct[],
  shopIds: Set<string> = new Set(),
): Set<string> {
  for (const category of categories) {
    for (const product of category.products ?? []) {
      const productShopId = product[ProductKeys.ShopId];
      if (productShopId) {
        shopIds.add(productShopId);
      }
    }
    if (category.children?.length) {
      collectProductShopIds(category.children, shopIds);
    }
  }
  return shopIds;
}
